import http from 'conversations-http/clients/http';
export const fetchThreadDeliveryIdentifierData = ({
  threadId
}) => {
  return http.get(`conversations-threads/v1/thread-attributes/${threadId}/delivery-identifiers`);
};